/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerOverrideDocumentTypeMutationResponse, DocumentUseCasesControllerOverrideDocumentTypePathParams } from "../../models/documentUseCasesController/DocumentUseCasesControllerOverrideDocumentType";

function getDocumentUseCasesControllerOverrideDocumentTypeUrl(id: DocumentUseCasesControllerOverrideDocumentTypePathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/documents/${id}/document-type-overrides` as const }  
  return res
}

/**
 * @description Supersedes the classifier verdict and stops later runs from overwriting it. Not PATCH /documents/:id, which takes an unvalidated string and records no provenance.
 * @summary Set a document's type manually
 * {@link /api/v1/documents/:id/document-type-overrides}
 */
export async function documentUseCasesControllerOverrideDocumentType(id: DocumentUseCasesControllerOverrideDocumentTypePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerOverrideDocumentTypeMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDocumentUseCasesControllerOverrideDocumentTypeUrl(id).url.toString(), ... requestConfig })  
  return res.data
}